/**
 * Landing.tsx
 * Home screen: sign-in if not authenticated, otherwise show the 3-button menu.
 */

import { useNavigate } from 'react-router-dom'
import { useAuth, GoogleSignInButton } from '../auth'

export default function Landing() {
  const { user, signInWithCredential, signOut } = useAuth()
  const navigate = useNavigate()

  function handleSignIn(idToken: string) {
    signInWithCredential(idToken)
    // The auth context re-renders this component; no explicit nav needed.
  }

  function handleSignInError() {
    // GIS sign-in was dismissed or failed — stay on landing.
  }

  return (
    <div className="wrap">
      <div className="brand">
        <div className="brand-logo">N73AA</div>
        <div className="brand-tag">Beechcraft Bonanza N35 &mdash; Logging</div>
      </div>

      {!user ? (
        <div className="card">
          <div className="signin-wrap">
            <p className="signin-copy">
              Sign in with your Google account to log flights, fuel, and
              expenses for N73AA.
            </p>
            <GoogleSignInButton
              onSuccess={handleSignIn}
              onError={handleSignInError}
            />
          </div>
        </div>
      ) : (
        <>
          <div className="who">
            Logging as: <strong>{user.name}</strong>
          </div>

          <a
            className="menu-btn"
            style={{ background: '#1a73e8' }}
            href="/flight"
            onClick={(e) => {
              e.preventDefault()
              navigate('/flight')
            }}
          >
            <div className="menu-btn-title">Log a Flight</div>
            <div className="menu-btn-sub">Tach in/out for one flight</div>
          </a>

          <a
            className="menu-btn"
            style={{ background: '#e8710a' }}
            href="/fuel"
            onClick={(e) => {
              e.preventDefault()
              navigate('/fuel')
            }}
          >
            <div className="menu-btn-title">Log Fuel</div>
            <div className="menu-btn-sub">Gallons, cost, receipt photo</div>
          </a>

          <a
            className="menu-btn"
            style={{ background: '#188038' }}
            href="/expense"
            onClick={(e) => {
              e.preventDefault()
              navigate('/expense')
            }}
          >
            <div className="menu-btn-title">Log an Expense</div>
            <div className="menu-btn-sub">Vendor bill or incidental</div>
          </a>

          <a
            className="menu-btn"
            style={{ background: '#1a3a5a' }}
            href="/entries?quarter=current&tab=flights"
            onClick={(e) => {
              e.preventDefault()
              navigate('/entries?quarter=current&tab=flights')
            }}
          >
            <div className="menu-btn-title">View Entries</div>
            <div className="menu-btn-sub">Flights, fuel, expenses by quarter</div>
          </a>

          <div className="page-foot">
            <button
              style={{
                background: 'none',
                border: 'none',
                color: '#9aa0a6',
                fontSize: '11px',
                cursor: 'pointer',
                padding: 0,
              }}
              onClick={signOut}
            >
              Sign out
            </button>
          </div>
        </>
      )}

      <div className="page-foot">Bookmark this page. Tap a button to log.</div>
    </div>
  )
}
